import { render, staticRenderFns } from "./WorkersSkillsTable.vue?vue&type=template&id=333446d6&scoped=true&"
import script from "./WorkersSkillsTable.vue?vue&type=script&lang=js&"
export * from "./WorkersSkillsTable.vue?vue&type=script&lang=js&"
import style0 from "./WorkersSkillsTable.vue?vue&type=style&index=0&id=333446d6&lang=scss&scoped=true&"
import style1 from "./WorkersSkillsTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333446d6",
  null
  
)

export default component.exports